<div class="tw-flex tw-items-start tw-gap-4">
  <div
    aria-hidden="true"
    class="tw-flex tw-items-center tw-justify-center tw-w-11 tw-h-11 tw-rounded-full tw-flex-shrink-0 tw-border"
    [ngClass]="[config.bgClass, config.shadowClass, config.borderClass]"
  >
    <icon [name]="config.iconName" [size]="5" [ngClass]="config.textClass"></icon>
  </div>
  <div class="tw-text-xl tw-font-semibold tw-text-dt-text-headings tw-leading-snug tw-pt-1">
    {{ title }}
  </div>
</div>
